import { render } from "./when.vue?vue&type=template&id=2912f4ce&lang=pug"
import script from "./when.vue?vue&type=script&lang=js"
export * from "./when.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__